var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.testCaseDetailsToggle
    ? _c(
        "page-outline",
        { attrs: { title: _vm.$t("injection_tab.test_case_details") } },
        [
          _c("template", { slot: "pageContent" }, [
            _c(
              "div",
              { attrs: { slot: "pageContent" }, slot: "pageContent" },
              [
                _c("b-container", { attrs: { fluid: "" } }, [
                  _c(
                    "div",
                    {
                      key: _vm.updateDetailsPanel,
                      staticClass: "flex h-screen",
                    },
                    [
                      _c(
                        "b-row",
                        { staticClass: "mb-5" },
                        [
                          _c(
                            "b-col",
                            { attrs: { sm: "2" } },
                            [
                              _c(
                                "b-button",
                                {
                                  staticClass: "btnBack mx-2 px-2 py-1 w-100",
                                  attrs: { variant: "secondary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.closeTestCaseDetails(
                                        _vm.testCase
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "fas fa-arrow-left",
                                    staticStyle: { "font-size": "15px" },
                                  }),
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$t("injection_tab.back")) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { sm: "2" } },
                            [
                              _c(
                                "b-button",
                                {
                                  staticClass:
                                    "btnRefresh mx-2 px-2 py-1 w-100",
                                  attrs: { variant: "secondary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.refreshDetails(_vm.testCase)
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "fas fa-rotate-right",
                                    staticStyle: { "font-size": "15px" },
                                  }),
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$t("injection_tab.refresh")) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("b-col", { attrs: { sm: "" } }),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { sm: "2" } },
                            [
                              _c(
                                "b-button",
                                {
                                  staticClass:
                                    "btnAddDataset ml-2 px-2 py-1 w-100",
                                  attrs: { variant: "secondary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.addDataset(_vm.testCase)
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "fas fa-plus-circle",
                                    staticStyle: { "font-size": "15px" },
                                  }),
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t("injection_tab.add_dataset")
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "mb-3" },
                        [
                          _c(
                            "b-col",
                            { attrs: { sm: "12" } },
                            [
                              _c(
                                "form-accordion",
                                {
                                  attrs: {
                                    title: _vm.$t(
                                      "injection_tab.test_case.details"
                                    ),
                                    isTitleUpperCase: false,
                                  },
                                },
                                [
                                  _c(
                                    "b-row",
                                    { staticClass: "justify-content-start" },
                                    [
                                      _c("b-col", { attrs: { sm: "1" } }, [
                                        _c("p", { staticClass: "mb-0" }, [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("account_tb.id"))
                                            ),
                                          ]),
                                        ]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(_vm._s(_vm.testCase.id)),
                                        ]),
                                      ]),
                                      _vm._v(" "),
                                      _c("b-col", [
                                        _c("p", { staticClass: "mb-0" }, [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "injection_tab.test_case.case_summary"
                                                )
                                              )
                                            ),
                                          ]),
                                        ]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                `toolbox.resp_summary_case.${_vm.testCase.caseSummary}`
                                              )
                                            )
                                          ),
                                        ]),
                                      ]),
                                      _vm._v(" "),
                                      _c("b-col", [
                                        _c("p", { staticClass: "mb-0" }, [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "injection_tab.test_case.response_status"
                                                )
                                              )
                                            ),
                                          ]),
                                        ]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(_vm.testCase.expectedResult)
                                          ),
                                        ]),
                                      ]),
                                      _vm._v(" "),
                                      _c("b-col", [
                                        _c("p", { staticClass: "mb-0" }, [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "injection_tab.test_case.date_last_test"
                                                )
                                              )
                                            ),
                                          ]),
                                        ]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("formatDateTime")(
                                                _vm.testCase.lastExecDate
                                              )
                                            )
                                          ),
                                        ]),
                                      ]),
                                      _vm._v(" "),
                                      _c("b-col", [
                                        _c("p", { staticClass: "mb-0" }, [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "injection_tab.test_case.number_req_resp"
                                                )
                                              )
                                            ),
                                          ]),
                                        ]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(_vm.testCase.nbOK) +
                                              " / " +
                                              _vm._s(
                                                _vm.testCase.datasets.length
                                              )
                                          ),
                                        ]),
                                      ]),
                                      _vm._v(" "),
                                      _c("b-col", [
                                        _c("p", { staticClass: "mb-0" }, [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "injection_tab.last_status"
                                                )
                                              )
                                            ),
                                          ]),
                                        ]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm.testCase.AllStatusOk === "2" ||
                                          _vm.testCase.AllStatusOk === "OK"
                                            ? _c("i", {
                                                staticClass:
                                                  "fas fa-check bg-success text-white rounded-circle d-flex align-items-center justify-content-center",
                                                staticStyle: {
                                                  width: "20px",
                                                  height: "20px",
                                                },
                                                attrs: { title: "OK" },
                                              })
                                            : _vm.testCase.AllStatusOk ===
                                                "0" ||
                                              _vm.testCase.AllStatusOk === "KO"
                                            ? _c("i", {
                                                staticClass:
                                                  "fas fa-times bg-danger text-white rounded-circle d-flex align-items-center justify-content-center",
                                                staticStyle: {
                                                  width: "20px",
                                                  height: "20px",
                                                },
                                                attrs: { title: "KO" },
                                              })
                                            : _vm.testCase.AllStatusOk === "3"
                                            ? _c("i", {
                                                staticClass: "fas fa-file-alt",
                                                staticStyle: {
                                                  color: "gray",
                                                  "font-size": "20px",
                                                },
                                                attrs: {
                                                  title:
                                                    "Missing configuration",
                                                },
                                              })
                                            : _vm.testCase.AllStatusOk === "4"
                                            ? _c("i", {
                                                staticClass:
                                                  "fas fa-hourglass-half",
                                                staticStyle: {
                                                  color: "gray",
                                                  "font-size": "20px",
                                                },
                                                attrs: { title: "Pending" },
                                              })
                                            : _vm.testCase.AllStatusOk ===
                                                "5" ||
                                              _vm.testCase.AllStatusOk ===
                                                "GRIS"
                                            ? _c("i", {
                                                staticClass:
                                                  "fas fa-minus bg-secondary text-white rounded-circle d-flex align-items-center justify-content-center",
                                                staticStyle: {
                                                  width: "20px",
                                                  height: "20px",
                                                },
                                                attrs: {
                                                  title: "Not tested yet",
                                                },
                                              })
                                            : _c(
                                                "span",
                                                { staticClass: "fs-21px" },
                                                [
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.testCase
                                                          .testCaseResult
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                        ]),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-row",
                                    { staticClass: "justify-content-start" },
                                    [
                                      _c("b-col", [
                                        _c("p", { staticClass: "mb-0" }, [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "injection_tab.test_case.case_description"
                                                )
                                              )
                                            ),
                                          ]),
                                        ]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                `toolbox.resp_description_case.${_vm.testCase.description}`
                                              )
                                            )
                                          ),
                                        ]),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("hr", { staticClass: "mb-4" }),
                      _vm._v(" "),
                      _vm._l(_vm.testCaseDatasets, function (dataset, index) {
                        return _vm.testCaseDatasets.length > 0
                          ? _c(
                              "b-row",
                              { key: dataset.id, staticClass: "pb-3" },
                              [
                                _c(
                                  "b-col",
                                  { attrs: { sm: "12" } },
                                  [
                                    _c(
                                      "form-accordion",
                                      {
                                        attrs: {
                                          title: _vm.buildDatasetName(
                                            index,
                                            false
                                          ),
                                          isTitleUpperCase: false,
                                        },
                                      },
                                      [
                                        _c(
                                          "form-accordion",
                                          {
                                            staticClass: "ml-3",
                                            attrs: {
                                              title: _vm.$t(
                                                "injection_tab.data_request"
                                              ),
                                              isTitleUpperCase: false,
                                            },
                                          },
                                          [
                                            _vm.testCase.datasetsRequirements
                                              .length
                                              ? [
                                                  _c(
                                                    "b-row",
                                                    {
                                                      staticClass:
                                                        "justify-content-start ml-1",
                                                    },
                                                    [
                                                      _c(
                                                        "b-col",
                                                        { attrs: { sm: "3" } },
                                                        [
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "mb-0",
                                                            },
                                                            [
                                                              _c("strong", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "account_tb.test_case_id"
                                                                    )
                                                                  )
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c("p", [
                                                            _vm._v(
                                                              _vm._s(dataset.id)
                                                            ),
                                                          ]),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "b-col",
                                                        { attrs: { sm: "3" } },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "d-flex align-items-center justify-content-start mb-0",
                                                            },
                                                            [
                                                              _c(
                                                                "p",
                                                                {
                                                                  staticClass:
                                                                    "mb-0",
                                                                },
                                                                [
                                                                  _c("strong", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "injection_tab.test_case.case_description"
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "mt-2 pt-0",
                                                            },
                                                            [
                                                              _c(
                                                                "form-write-group-label-input",
                                                                {
                                                                  attrs: {
                                                                    placeholderValue:
                                                                      "Description",
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      dataset.descriptionCase,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          dataset,
                                                                          "descriptionCase",
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "dataset.descriptionCase",
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "b-col",
                                                        { attrs: { sm: "3" } },
                                                        [
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "mb-0",
                                                            },
                                                            [
                                                              _c("strong", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "injection_tab.last_execution"
                                                                    )
                                                                  )
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          dataset.lastExecution
                                                            ? _c("p", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "formatDateTime"
                                                                    )(
                                                                      dataset.lastExecution
                                                                    )
                                                                  )
                                                                ),
                                                              ])
                                                            : _c("p", [
                                                                _vm._v("-"),
                                                              ]),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "b-col",
                                                        { attrs: { sm: "3" } },
                                                        [
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "mb-3",
                                                            },
                                                            [
                                                              _c("strong", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "injection_tab.last_status"
                                                                    )
                                                                  )
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          dataset.AllStatusOk ===
                                                          "2"
                                                            ? _c("i", {
                                                                staticClass:
                                                                  "fas fa-check bg-success text-white",
                                                                staticStyle: {
                                                                  "border-radius":
                                                                    "50%",
                                                                  display:
                                                                    "inline-flex",
                                                                  "justify-content":
                                                                    "center",
                                                                  "align-items":
                                                                    "center",
                                                                },
                                                                attrs: {
                                                                  title: "OK",
                                                                },
                                                              })
                                                            : dataset.AllStatusOk ===
                                                              "0"
                                                            ? _c("i", {
                                                                staticClass:
                                                                  "fas fa-times bg-danger text-white",
                                                                staticStyle: {
                                                                  "border-radius":
                                                                    "50%",
                                                                  display:
                                                                    "inline-flex",
                                                                  "justify-content":
                                                                    "center",
                                                                  "align-items":
                                                                    "center",
                                                                },
                                                                attrs: {
                                                                  title: "KO",
                                                                },
                                                              })
                                                            : dataset.AllStatusOk ===
                                                              "4"
                                                            ? _c("i", {
                                                                staticClass:
                                                                  "fas fa-hourglass-half",
                                                                staticStyle: {
                                                                  color: "gray",
                                                                  "font-size":
                                                                    "20px",
                                                                },
                                                                attrs: {
                                                                  title:
                                                                    "Pending",
                                                                },
                                                              })
                                                            : dataset.AllStatusOk ===
                                                              "3"
                                                            ? _c("i", {
                                                                staticClass:
                                                                  "fas fa-file-alt",
                                                                staticStyle: {
                                                                  color: "gray",
                                                                  "font-size":
                                                                    "20px",
                                                                },
                                                                attrs: {
                                                                  title:
                                                                    "Missing configuration",
                                                                },
                                                              })
                                                            : !dataset.AllStatusOk ||
                                                              dataset.AllStatusOk ===
                                                                "5"
                                                            ? _c("i", {
                                                                staticClass:
                                                                  "fas fa-minus bg-secondary text-white",
                                                                staticStyle: {
                                                                  "border-radius":
                                                                    "50%",
                                                                  display:
                                                                    "inline-flex",
                                                                  "justify-content":
                                                                    "center",
                                                                  "align-items":
                                                                    "center",
                                                                  width: "20px",
                                                                  height:
                                                                    "20px",
                                                                },
                                                                attrs: {
                                                                  title:
                                                                    "Not tested yet",
                                                                },
                                                              })
                                                            : _c("p", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    dataset.resultTest
                                                                  )
                                                                ),
                                                              ]),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm._l(
                                                        _vm.testCase
                                                          .datasetsRequirementsRequest,
                                                        function (
                                                          requirement,
                                                          index
                                                        ) {
                                                          return _vm.testCase
                                                            .datasetsRequirementsRequest &&
                                                            _vm.testCase
                                                              .datasetsRequirementsRequest
                                                              .length
                                                            ? [
                                                                dataset.datas.some(
                                                                  (data) =>
                                                                    data.field ===
                                                                      requirement.field &&
                                                                    data.messageType ===
                                                                      requirement.messageType
                                                                ) &&
                                                                requirement.messageType ===
                                                                  "0"
                                                                  ? _c(
                                                                      "b-col",
                                                                      {
                                                                        staticClass:
                                                                          "form-group",
                                                                        attrs: {
                                                                          sm: "3",
                                                                        },
                                                                      },
                                                                      [
                                                                        [
                                                                          requirement.fieldEditable !==
                                                                          "1"
                                                                            ? _c(
                                                                                "div",
                                                                                [
                                                                                  _c(
                                                                                    "p",
                                                                                    {
                                                                                      staticClass:
                                                                                        "mb-0",
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "strong",
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              requirement.field
                                                                                            )
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                  _vm._v(
                                                                                    " "
                                                                                  ),
                                                                                  _c(
                                                                                    "p",
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          dataset.datas.find(
                                                                                            (
                                                                                              data
                                                                                            ) =>
                                                                                              data.field ===
                                                                                                requirement.field &&
                                                                                              data.messageType ===
                                                                                                requirement.messageType
                                                                                          )
                                                                                            .fieldValue
                                                                                        )
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ]
                                                                              )
                                                                            : _c(
                                                                                "form-write-group-label-input",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      inputLabel:
                                                                                        requirement.field,
                                                                                      placeholderValue:
                                                                                        requirement.field,
                                                                                    },
                                                                                  model:
                                                                                    {
                                                                                      value:
                                                                                        dataset.datas.find(
                                                                                          (
                                                                                            data
                                                                                          ) =>
                                                                                            data.field ===
                                                                                              requirement.field &&
                                                                                            data.messageType ===
                                                                                              requirement.messageType
                                                                                        )
                                                                                          .tmpFieldValue,
                                                                                      callback:
                                                                                        function (
                                                                                          $$v
                                                                                        ) {
                                                                                          _vm.$set(
                                                                                            dataset.datas.find(
                                                                                              (
                                                                                                data
                                                                                              ) =>
                                                                                                data.field ===
                                                                                                  requirement.field &&
                                                                                                data.messageType ===
                                                                                                  requirement.messageType
                                                                                            ),
                                                                                            "tmpFieldValue",
                                                                                            $$v
                                                                                          )
                                                                                        },
                                                                                      expression:
                                                                                        "dataset.datas.find(data => data.field === requirement.field && data.messageType === requirement.messageType).tmpFieldValue",
                                                                                    },
                                                                                }
                                                                              ),
                                                                        ],
                                                                      ],
                                                                      2
                                                                    )
                                                                  : _vm._e(),
                                                              ]
                                                            : _vm._e()
                                                        }
                                                      ),
                                                    ],
                                                    2
                                                  ),
                                                  _vm._v(" "),
                                                  _c("b-table", {
                                                    staticClass:
                                                      "table table-striped",
                                                    attrs: {
                                                      responsive: "",
                                                      "thead-class": "d-none",
                                                      fields:
                                                        _vm.fieldsDatasetRequirements(
                                                          _vm.testCase
                                                            .datasetsRequirementsRequest
                                                        ),
                                                      items:
                                                        _vm.itemsDatasetRequirements(
                                                          _vm.testCase
                                                            .datasetsRequirementsRequest
                                                        ),
                                                    },
                                                  }),
                                                ]
                                              : _vm._e(),
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _vm.testCase
                                          .datasetsRequirementsResponse &&
                                        _vm.testCase
                                          .datasetsRequirementsResponse.length
                                          ? _c(
                                              "form-accordion",
                                              {
                                                staticClass: "ml-3",
                                                attrs: {
                                                  title: _vm.$t(
                                                    "injection_tab.response"
                                                  ),
                                                  isTitleUpperCase: false,
                                                },
                                              },
                                              [
                                                _c(
                                                  "b-row",
                                                  {
                                                    staticClass:
                                                      "justify-content-start ml-3",
                                                  },
                                                  [
                                                    _vm._l(
                                                      _vm.testCase
                                                        .datasetsRequirementsResponse,
                                                      function (
                                                        requirement,
                                                        index
                                                      ) {
                                                        return [
                                                          dataset.datas.some(
                                                            (data) =>
                                                              data.field ===
                                                                requirement.field &&
                                                              data.messageType ===
                                                                requirement.messageType
                                                          ) &&
                                                          requirement.messageType ===
                                                            "1"
                                                            ? _c(
                                                                "b-col",
                                                                {
                                                                  staticClass:
                                                                    "form-group",
                                                                  attrs: {
                                                                    sm: "3",
                                                                  },
                                                                },
                                                                [
                                                                  [
                                                                    requirement.fieldEditable !==
                                                                    "1"
                                                                      ? _c(
                                                                          "div",
                                                                          [
                                                                            _c(
                                                                              "p",
                                                                              {
                                                                                staticClass:
                                                                                  "mb-0",
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "strong",
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        requirement.field
                                                                                      )
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "p",
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    dataset.datas.find(
                                                                                      (
                                                                                        data
                                                                                      ) =>
                                                                                        data.field ===
                                                                                          requirement.field &&
                                                                                        data.messageType ===
                                                                                          requirement.messageType
                                                                                    )
                                                                                      .fieldValue
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _c(
                                                                          "form-write-group-label-input",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                inputLabel:
                                                                                  requirement.field,
                                                                                placeholderValue:
                                                                                  requirement.field,
                                                                              },
                                                                            model:
                                                                              {
                                                                                value:
                                                                                  dataset.datas.find(
                                                                                    (
                                                                                      data
                                                                                    ) =>
                                                                                      data.field ===
                                                                                        requirement.field &&
                                                                                      data.messageType ===
                                                                                        requirement.messageType
                                                                                  )
                                                                                    .tmpFieldValue,
                                                                                callback:
                                                                                  function (
                                                                                    $$v
                                                                                  ) {
                                                                                    _vm.$set(
                                                                                      dataset.datas.find(
                                                                                        (
                                                                                          data
                                                                                        ) =>
                                                                                          data.field ===
                                                                                            requirement.field &&
                                                                                          data.messageType ===
                                                                                            requirement.messageType
                                                                                      ),
                                                                                      "tmpFieldValue",
                                                                                      $$v
                                                                                    )
                                                                                  },
                                                                                expression:
                                                                                  "dataset.datas.find(data => data.field === requirement.field && data.messageType === requirement.messageType).tmpFieldValue",
                                                                              },
                                                                          }
                                                                        ),
                                                                  ],
                                                                ],
                                                                2
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          (index + 1) % 4 ===
                                                            0 ||
                                                          index ===
                                                            _vm.testCase.datasetsRequirements.filter(
                                                              (req) =>
                                                                req.fieldEditable ===
                                                                1
                                                            ).length -
                                                              1
                                                            ? _c("b-row")
                                                            : _vm._e(),
                                                        ]
                                                      }
                                                    ),
                                                  ],
                                                  2
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "form-accordion",
                                          {
                                            staticClass: "ml-3",
                                            attrs: {
                                              title: _vm.$t(
                                                "injection_tab.history"
                                              ),
                                              isTitleUpperCase: false,
                                            },
                                          },
                                          [
                                            _c(
                                              "b-row",
                                              {
                                                staticClass:
                                                  "mb-3 justify-content-start ml-3 mr-3",
                                              },
                                              [
                                                _c("b-table", {
                                                  staticClass:
                                                    "table table-striped",
                                                  attrs: {
                                                    responsive: "",
                                                    "thead-class": "d-none",
                                                    "current-page":
                                                      _vm.pageCounter,
                                                    fields:
                                                      _vm.fieldsHistoryTab,
                                                    items: dataset.history,
                                                    "per-page":
                                                      _vm.paginationObject
                                                        .maxResults,
                                                    "sort-by": _vm.sortBy,
                                                    "sort-desc": _vm.sortDir,
                                                    "sort-by": "executionDate",
                                                    "sort-desc": false,
                                                  },
                                                  on: {
                                                    "update:sortBy": function (
                                                      $event
                                                    ) {
                                                      _vm.sortBy = $event
                                                    },
                                                    "update:sort-by": function (
                                                      $event
                                                    ) {
                                                      _vm.sortBy = $event
                                                    },
                                                    "update:sortDesc":
                                                      function ($event) {
                                                        _vm.sortDir = $event
                                                      },
                                                    "update:sort-desc":
                                                      function ($event) {
                                                        _vm.sortDir = $event
                                                      },
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "cell(testCaseStatus)",
                                                        fn: function (data) {
                                                          return [
                                                            data.value === "2"
                                                              ? _c("i", {
                                                                  staticClass:
                                                                    "fas fa-check bg-success text-white",
                                                                  staticStyle: {
                                                                    "border-radius":
                                                                      "50%",
                                                                    display:
                                                                      "inline-flex",
                                                                    "justify-content":
                                                                      "center",
                                                                    "align-items":
                                                                      "center",
                                                                  },
                                                                  attrs: {
                                                                    title: "OK",
                                                                  },
                                                                })
                                                              : data.value ===
                                                                "0"
                                                              ? _c("i", {
                                                                  staticClass:
                                                                    "fas fa-times bg-danger text-white",
                                                                  staticStyle: {
                                                                    "border-radius":
                                                                      "50%",
                                                                    display:
                                                                      "inline-flex",
                                                                    "justify-content":
                                                                      "center",
                                                                    "align-items":
                                                                      "center",
                                                                  },
                                                                  attrs: {
                                                                    title: "KO",
                                                                  },
                                                                })
                                                              : data.value ===
                                                                "4"
                                                              ? _c("i", {
                                                                  staticClass:
                                                                    "fas fa-hourglass-half",
                                                                  staticStyle: {
                                                                    color:
                                                                      "gray",
                                                                    "font-size":
                                                                      "20px",
                                                                  },
                                                                  attrs: {
                                                                    title:
                                                                      "Pending",
                                                                  },
                                                                })
                                                              : data.value ===
                                                                "3"
                                                              ? _c("i", {
                                                                  staticClass:
                                                                    "fas fa-file-alt",
                                                                  staticStyle: {
                                                                    color:
                                                                      "gray",
                                                                    "font-size":
                                                                      "20px",
                                                                  },
                                                                  attrs: {
                                                                    title:
                                                                      "Missing configuration",
                                                                  },
                                                                })
                                                              : data.value ===
                                                                "5"
                                                              ? _c("i", {
                                                                  staticClass:
                                                                    "fas fa-minus bg-secondary text-white",
                                                                  staticStyle: {
                                                                    "border-radius":
                                                                      "50%",
                                                                    display:
                                                                      "inline-flex",
                                                                    "justify-content":
                                                                      "center",
                                                                    "align-items":
                                                                      "center",
                                                                  },
                                                                  attrs: {
                                                                    title:
                                                                      "Not tested yet",
                                                                  },
                                                                })
                                                              : _c("p", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      data.value
                                                                    )
                                                                  ),
                                                                ]),
                                                          ]
                                                        },
                                                      },
                                                      {
                                                        key: "cell(testCaseStatusCode)",
                                                        fn: function (data) {
                                                          return [
                                                            _vm._v(
                                                              "\n                        " +
                                                                _vm._s(
                                                                  data.value
                                                                    ? _vm.$t(
                                                                        "toolbox.error-status." +
                                                                          data.value
                                                                      ) !==
                                                                      "toolbox.error-status." +
                                                                        data.value
                                                                      ? _vm.$t(
                                                                          "toolbox.error-status." +
                                                                            data.value
                                                                        )
                                                                      : data.value
                                                                    : "-"
                                                                ) +
                                                                "\n                      "
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                      {
                                                        key: "cell(executionDate)",
                                                        fn: function (data) {
                                                          return [
                                                            _vm._v(
                                                              "\n                        " +
                                                                _vm._s(
                                                                  _vm.parseHistoryDate(
                                                                    data.value
                                                                  )
                                                                ) +
                                                                "\n                      "
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                      {
                                                        key: "cell(buttons)",
                                                        fn: function (data) {
                                                          return [
                                                            data.item
                                                              .testCaseStatus !=
                                                            "3"
                                                              ? _c("i", {
                                                                  staticClass:
                                                                    "fas fa-eye px-1 cursor-pointer",
                                                                  staticStyle: {
                                                                    color:
                                                                      "var(--actionButtonColorBlue)",
                                                                    "font-size":
                                                                      "15px",
                                                                  },
                                                                  attrs: {
                                                                    title:
                                                                      "Open",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.openHistory(
                                                                          data
                                                                            .item
                                                                            .idVopMessageOrigin,
                                                                          data
                                                                            .item
                                                                            .testCaseStatus,
                                                                          "see"
                                                                        )
                                                                      },
                                                                  },
                                                                })
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            data.item
                                                              .testCaseStatus !=
                                                            "3"
                                                              ? _c("i", {
                                                                  staticClass:
                                                                    "fas fa-download px-1 cursor-pointer",
                                                                  staticStyle: {
                                                                    color:
                                                                      "var(--actionButtonColorBlue)",
                                                                    "font-size":
                                                                      "15px",
                                                                  },
                                                                  attrs: {
                                                                    title:
                                                                      "Download",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.openHistory(
                                                                          data
                                                                            .item
                                                                            .idVopMessageOrigin,
                                                                          data
                                                                            .item
                                                                            .testCaseStatus,
                                                                          "download"
                                                                        )
                                                                      },
                                                                  },
                                                                })
                                                              : _vm._e(),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-row",
                                          {
                                            staticClass:
                                              "pb-3 justify-content-center",
                                          },
                                          [
                                            _vm.$engine.rights.rightIs(
                                              "DataSetResponder_editer",
                                              true
                                            )
                                              ? _c(
                                                  "b-col",
                                                  { attrs: { sm: "2" } },
                                                  [
                                                    _c(
                                                      "b-button",
                                                      {
                                                        staticClass:
                                                          "btnSaveDataset mx-2 px-2 py-1 w-100",
                                                        attrs: {
                                                          variant: "secondary",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.putDataset(
                                                              dataset,
                                                              _vm.testCase
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "injection_tab.save_data"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.$engine.rights.rightIs(
                                              "ExecutionResponder_add",
                                              true
                                            )
                                              ? _c(
                                                  "b-col",
                                                  { attrs: { sm: "2" } },
                                                  [
                                                    _c(
                                                      "b-button",
                                                      {
                                                        staticClass:
                                                          "btnSend mx-2 px-2 py-1 w-100",
                                                        attrs: {
                                                          variant: "primary",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.runDataset(
                                                              dataset
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "injection_tab.send_again"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.$engine.rights.rightIs(
                                              "DataSetResponder_supprimer",
                                              true
                                            ) && _vm.testCaseDatasets.length > 1
                                              ? _c(
                                                  "b-col",
                                                  { attrs: { sm: "2" } },
                                                  [
                                                    _c(
                                                      "b-button",
                                                      {
                                                        staticClass:
                                                          "btnSend mx-2 px-2 py-1 w-100",
                                                        attrs: {
                                                          variant: "primary",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.deleteDataset(
                                                              dataset
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "common.del_label"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("hr"),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e()
                      }),
                      _vm._v(" "),
                      _vm._l(
                        _vm.testCase.tmpDatasets,
                        function (tmpDataset, index) {
                          return _vm.testCase.tmpDatasets.length > 0
                            ? _c(
                                "b-row",
                                { key: tmpDataset.id, staticClass: "pb-3" },
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "12" } },
                                    [
                                      _c(
                                        "form-accordion",
                                        {
                                          attrs: {
                                            title: _vm.buildDatasetName(
                                              index,
                                              true
                                            ),
                                            isTitleUpperCase: false,
                                          },
                                        },
                                        [
                                          _vm.testCase.datasetsRequirements
                                            .length
                                            ? _c(
                                                "form-accordion",
                                                {
                                                  staticClass: "ml-3",
                                                  attrs: {
                                                    title: _vm.$t(
                                                      "injection_tab.data_request"
                                                    ),
                                                    isTitleUpperCase: false,
                                                  },
                                                },
                                                [
                                                  [
                                                    _c(
                                                      "b-row",
                                                      {
                                                        staticClass:
                                                          "justify-content-start ml-1",
                                                      },
                                                      [
                                                        tmpDataset.id
                                                          ? _c("b-col", {
                                                              attrs: {
                                                                sm: "3",
                                                              },
                                                            })
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _c(
                                                          "b-col",
                                                          {
                                                            attrs: { sm: "3" },
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "d-flex align-items-center justify-content-start mb-0",
                                                              },
                                                              [
                                                                _c(
                                                                  "p",
                                                                  {
                                                                    staticClass:
                                                                      "mb-0",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "strong",
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "injection_tab.test_case.case_description"
                                                                            )
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "mt-2 pt-0",
                                                              },
                                                              [
                                                                _c(
                                                                  "form-write-group-label-input",
                                                                  {
                                                                    attrs: {
                                                                      placeholderValue:
                                                                        "Description",
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        tmpDataset.descriptionCase,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            tmpDataset,
                                                                            "descriptionCase",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "tmpDataset.descriptionCase",
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "b-col",
                                                          {
                                                            attrs: { sm: "3" },
                                                          },
                                                          [
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "mb-0",
                                                              },
                                                              [
                                                                _c("strong", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "injection_tab.last_execution"
                                                                      )
                                                                    )
                                                                  ),
                                                                ]),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c("p", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  tmpDataset.lastExecution
                                                                )
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "b-col",
                                                          {
                                                            attrs: { sm: "3" },
                                                          },
                                                          [
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "mb-3",
                                                              },
                                                              [
                                                                _c("strong", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "injection_tab.last_status"
                                                                      )
                                                                    )
                                                                  ),
                                                                ]),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            tmpDataset.resultTest ===
                                                            "2"
                                                              ? _c("i", {
                                                                  staticClass:
                                                                    "fas fa-check bg-success text-white",
                                                                  staticStyle: {
                                                                    "border-radius":
                                                                      "50%",
                                                                    display:
                                                                      "inline-flex",
                                                                    "justify-content":
                                                                      "center",
                                                                    "align-items":
                                                                      "center",
                                                                  },
                                                                  attrs: {
                                                                    title: "OK",
                                                                  },
                                                                })
                                                              : tmpDataset.resultTest ===
                                                                "0"
                                                              ? _c("i", {
                                                                  staticClass:
                                                                    "fas fa-times bg-danger text-white",
                                                                  staticStyle: {
                                                                    "border-radius":
                                                                      "50%",
                                                                    display:
                                                                      "inline-flex",
                                                                    "justify-content":
                                                                      "center",
                                                                    "align-items":
                                                                      "center",
                                                                  },
                                                                  attrs: {
                                                                    title: "KO",
                                                                  },
                                                                })
                                                              : tmpDataset.resultTest ===
                                                                "4"
                                                              ? _c("i", {
                                                                  staticClass:
                                                                    "fas fa-hourglass-half",
                                                                  staticStyle: {
                                                                    color:
                                                                      "gray",
                                                                    "font-size":
                                                                      "20px",
                                                                  },
                                                                  attrs: {
                                                                    title:
                                                                      "Pending",
                                                                  },
                                                                })
                                                              : tmpDataset.resultTest ===
                                                                "3"
                                                              ? _c("i", {
                                                                  staticClass:
                                                                    "fas fa-file-alt",
                                                                  staticStyle: {
                                                                    color:
                                                                      "gray",
                                                                    "font-size":
                                                                      "20px",
                                                                  },
                                                                  attrs: {
                                                                    title:
                                                                      "Missing configuration",
                                                                  },
                                                                })
                                                              : tmpDataset.resultTest ===
                                                                "5"
                                                              ? _c("i", {
                                                                  staticClass:
                                                                    "fas fa-minus bg-secondary text-white",
                                                                  staticStyle: {
                                                                    "border-radius":
                                                                      "50%",
                                                                    display:
                                                                      "inline-flex",
                                                                    "justify-content":
                                                                      "center",
                                                                    "align-items":
                                                                      "center",
                                                                  },
                                                                  attrs: {
                                                                    title:
                                                                      "Not tested yet",
                                                                  },
                                                                })
                                                              : _c("p", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      tmpDataset.resultTest
                                                                    )
                                                                  ),
                                                                ]),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _vm._l(
                                                          _vm.testCase
                                                            .datasetsRequirementsRequest,
                                                          function (
                                                            requirement,
                                                            index
                                                          ) {
                                                            return [
                                                              tmpDataset.datas.some(
                                                                (data) =>
                                                                  data.field ===
                                                                    requirement.field &&
                                                                  data.messageType ===
                                                                    requirement.messageType
                                                              ) &&
                                                              requirement.messageType ===
                                                                "0"
                                                                ? _c(
                                                                    "b-col",
                                                                    {
                                                                      staticClass:
                                                                        "form-group",
                                                                      attrs: {
                                                                        sm: "3",
                                                                      },
                                                                    },
                                                                    [
                                                                      [
                                                                        requirement.fieldEditable !==
                                                                        "1"
                                                                          ? _c(
                                                                              "div",
                                                                              [
                                                                                _c(
                                                                                  "p",
                                                                                  {
                                                                                    staticClass:
                                                                                      "mb-0",
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "strong",
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            requirement.field
                                                                                          )
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "p",
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        tmpDataset.datas.find(
                                                                                          (
                                                                                            data
                                                                                          ) =>
                                                                                            data.field ===
                                                                                              requirement.field &&
                                                                                            data.messageType ===
                                                                                              requirement.messageType
                                                                                        )
                                                                                          .fieldValue
                                                                                      )
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                              ]
                                                                            )
                                                                          : _c(
                                                                              "form-write-group-label-input",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    inputLabel:
                                                                                      requirement.field,
                                                                                    placeholderValue:
                                                                                      requirement.field,
                                                                                  },
                                                                                model:
                                                                                  {
                                                                                    value:
                                                                                      tmpDataset.datas.find(
                                                                                        (
                                                                                          data
                                                                                        ) =>
                                                                                          data.field ===
                                                                                            requirement.field &&
                                                                                          data.messageType ===
                                                                                            requirement.messageType
                                                                                      )
                                                                                        .tmpFieldValue,
                                                                                    callback:
                                                                                      function (
                                                                                        $$v
                                                                                      ) {
                                                                                        _vm.$set(
                                                                                          tmpDataset.datas.find(
                                                                                            (
                                                                                              data
                                                                                            ) =>
                                                                                              data.field ===
                                                                                                requirement.field &&
                                                                                              data.messageType ===
                                                                                                requirement.messageType
                                                                                          ),
                                                                                          "tmpFieldValue",
                                                                                          $$v
                                                                                        )
                                                                                      },
                                                                                    expression:
                                                                                      "tmpDataset.datas.find(data => data.field === requirement.field && data.messageType === requirement.messageType).tmpFieldValue",
                                                                                  },
                                                                              }
                                                                            ),
                                                                      ],
                                                                    ],
                                                                    2
                                                                  )
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              (index + 1) %
                                                                4 ===
                                                                0 ||
                                                              index ===
                                                                _vm.testCase.datasetsRequirements.filter(
                                                                  (req) =>
                                                                    req.fieldEditable ===
                                                                    1
                                                                ).length -
                                                                  1
                                                                ? _c("b-row")
                                                                : _vm._e(),
                                                            ]
                                                          }
                                                        ),
                                                      ],
                                                      2
                                                    ),
                                                  ],
                                                ],
                                                2
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.testCase
                                            .datasetsRequirementsResponse &&
                                          _vm.testCase
                                            .datasetsRequirementsResponse.length
                                            ? _c(
                                                "form-accordion",
                                                {
                                                  staticClass: "ml-3",
                                                  attrs: {
                                                    title: _vm.$t(
                                                      "injection_tab.response"
                                                    ),
                                                    isTitleUpperCase: false,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "b-row",
                                                    {
                                                      staticClass:
                                                        "justify-content-start ml-3",
                                                    },
                                                    [
                                                      _vm._l(
                                                        _vm.testCase
                                                          .datasetsRequirementsResponse,
                                                        function (
                                                          requirement,
                                                          index
                                                        ) {
                                                          return [
                                                            tmpDataset.datas.some(
                                                              (data) =>
                                                                data.field ===
                                                                  requirement.field &&
                                                                data.messageType ===
                                                                  requirement.messageType
                                                            ) &&
                                                            requirement.messageType ===
                                                              "1"
                                                              ? _c(
                                                                  "b-col",
                                                                  {
                                                                    staticClass:
                                                                      "form-group",
                                                                    attrs: {
                                                                      sm: "3",
                                                                    },
                                                                  },
                                                                  [
                                                                    [
                                                                      requirement.fieldEditable !==
                                                                      "1"
                                                                        ? _c(
                                                                            "div",
                                                                            [
                                                                              _c(
                                                                                "p",
                                                                                {
                                                                                  staticClass:
                                                                                    "mb-0",
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "strong",
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          requirement.field
                                                                                        )
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              _c(
                                                                                "p",
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      tmpDataset.datas.find(
                                                                                        (
                                                                                          data
                                                                                        ) =>
                                                                                          data.field ===
                                                                                            requirement.field &&
                                                                                          data.messageType ===
                                                                                            requirement.messageType
                                                                                      )
                                                                                        .fieldValue
                                                                                    )
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ]
                                                                          )
                                                                        : _c(
                                                                            "form-write-group-label-input",
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  inputLabel:
                                                                                    requirement.field,
                                                                                  placeholderValue:
                                                                                    requirement.field,
                                                                                },
                                                                              model:
                                                                                {
                                                                                  value:
                                                                                    tmpDataset.datas.find(
                                                                                      (
                                                                                        data
                                                                                      ) =>
                                                                                        data.field ===
                                                                                          requirement.field &&
                                                                                        data.messageType ===
                                                                                          requirement.messageType
                                                                                    )
                                                                                      .tmpFieldValue,
                                                                                  callback:
                                                                                    function (
                                                                                      $$v
                                                                                    ) {
                                                                                      _vm.$set(
                                                                                        tmpDataset.datas.find(
                                                                                          (
                                                                                            data
                                                                                          ) =>
                                                                                            data.field ===
                                                                                              requirement.field &&
                                                                                            data.messageType ===
                                                                                              requirement.messageType
                                                                                        ),
                                                                                        "tmpFieldValue",
                                                                                        $$v
                                                                                      )
                                                                                    },
                                                                                  expression:
                                                                                    "tmpDataset.datas.find(data => data.field === requirement.field && data.messageType === requirement.messageType).tmpFieldValue",
                                                                                },
                                                                            }
                                                                          ),
                                                                    ],
                                                                  ],
                                                                  2
                                                                )
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            (index + 1) % 4 ===
                                                              0 ||
                                                            index ===
                                                              _vm.testCase.datasetsRequirements.filter(
                                                                (req) =>
                                                                  req.fieldEditable ===
                                                                  1
                                                              ).length -
                                                                1
                                                              ? _c("b-row")
                                                              : _vm._e(),
                                                          ]
                                                        }
                                                      ),
                                                    ],
                                                    2
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "b-row",
                                            {
                                              staticClass:
                                                "pb-3 justify-content-center",
                                            },
                                            [
                                              _vm.$engine.rights.rightIs(
                                                "DataSetResponder_ajouter",
                                                true
                                              )
                                                ? _c(
                                                    "b-col",
                                                    { attrs: { sm: "2" } },
                                                    [
                                                      _c(
                                                        "b-button",
                                                        {
                                                          staticClass:
                                                            "btnSaveDataset mx-2 px-2 py-1 w-100",
                                                          attrs: {
                                                            variant:
                                                              "secondary",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.postDataset(
                                                                tmpDataset,
                                                                _vm.testCase,
                                                                index
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "injection_tab.save_data"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.$engine.rights.rightIs(
                                                "DataSetResponder_supprimer",
                                                true
                                              )
                                                ? _c(
                                                    "b-col",
                                                    { attrs: { sm: "2" } },
                                                    [
                                                      _c(
                                                        "b-button",
                                                        {
                                                          staticClass:
                                                            "btnSend mx-2 px-2 py-1 w-100",
                                                          attrs: {
                                                            variant: "primary",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.deleteDataset(
                                                                tmpDataset,
                                                                index
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "common.del_label"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("hr"),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e()
                        }
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "pb-3 justify-content-center" },
                        [
                          _vm.$engine.rights.rightIs(
                            "ExecutionResponder_add",
                            true
                          )
                            ? _c(
                                "b-col",
                                { attrs: { sm: "2" } },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass:
                                        "btnSendAgain mx-2 px-2 py-1 w-100",
                                      attrs: { variant: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.runTestCase(_vm.testCase)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "injection_tab.send_again_test_case"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ]),
              ],
              1
            ),
          ]),
        ],
        2
      )
    : _c(
        "page-outline",
        { attrs: { title: _vm.$t("Webheader.testCaseRequestedList") } },
        [
          _c("template", { slot: "pageContent" }, [
            _c(
              "div",
              { attrs: { slot: "pageContent" }, slot: "pageContent" },
              [
                _c(
                  "b-container",
                  { staticClass: "rounded shadow-sm", attrs: { fluid: "" } },
                  [
                    _c(
                      "div",
                      {
                        key: _vm.updateListPanel,
                        staticClass: "flex h-screen",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "mx-3" },
                          [
                            _c(
                              "b-row",
                              { staticClass: "mb-2 justify-content-end" },
                              [
                                _c(
                                  "b-col",
                                  {
                                    staticClass:
                                      "form-group d-flex flex-column",
                                    attrs: { sm: "2" },
                                  },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        staticClass:
                                          "btnImport mx-2 px-2 py-1 w-auto",
                                        attrs: {
                                          variant: "secondary",
                                          for: "fileInput",
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa-light fa-plus",
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticStyle: {
                                              color:
                                                "var(--actionTextColorWhite)",
                                            },
                                            attrs: { for: "fileInput" },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "injection_tab.import_test_case"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("input", {
                                      staticStyle: { display: "none" },
                                      attrs: {
                                        type: "file",
                                        id: "fileInput",
                                        accept: ".csv",
                                      },
                                      on: { change: _vm.importTestCases },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  {
                                    staticClass:
                                      "form-group d-flex flex-column",
                                    attrs: { sm: "2" },
                                  },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        staticClass:
                                          "btnFilter mx-2 px-2 py-1 w-auto",
                                        attrs: { variant: "secondary" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toggleFilter()
                                          },
                                        },
                                      },
                                      [
                                        _vm.filterToggle
                                          ? _c("i", {
                                              staticClass: "fa-light fa-minus",
                                            })
                                          : _c("i", {
                                              staticClass: "fa-light fa-plus",
                                            }),
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$t("injection_tab.filters")
                                            ) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  {
                                    staticClass:
                                      "form-group d-flex flex-column",
                                    attrs: { cols: "4", lg: "2", xl: "2" },
                                  },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        staticClass: "btnFilter",
                                        on: {
                                          click: function ($event) {
                                            return _vm.getTestsCases()
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "fa-light fa-rotate-right",
                                        }),
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(_vm.$t("common.rfrsh")) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.filterToggle
                              ? _c("hr", { staticClass: "my-3" })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.filterToggle
                              ? _c(
                                  "b-row",
                                  {
                                    staticClass: "mb-3 align-items-end",
                                    attrs: { "no-gutters": "" },
                                  },
                                  [
                                    _c("b-col", { attrs: { cols: "2" } }, [
                                      _c("div", [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "filter-item-title d-block mb-1",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "injection_tab.select_t_c_result"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.filterForm.caseStatus,
                                                expression:
                                                  "filterForm.caseStatus",
                                              },
                                            ],
                                            staticClass:
                                              "filter-item-content w-100",
                                            staticStyle: { padding: "0.5rem" },
                                            on: {
                                              change: function ($event) {
                                                var $$selectedVal =
                                                  Array.prototype.filter
                                                    .call(
                                                      $event.target.options,
                                                      function (o) {
                                                        return o.selected
                                                      }
                                                    )
                                                    .map(function (o) {
                                                      var val =
                                                        "_value" in o
                                                          ? o._value
                                                          : o.value
                                                      return val
                                                    })
                                                _vm.$set(
                                                  _vm.filterForm,
                                                  "caseStatus",
                                                  $event.target.multiple
                                                    ? $$selectedVal
                                                    : $$selectedVal[0]
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "option",
                                              {
                                                attrs: {
                                                  value: "",
                                                  selected: "",
                                                },
                                              },
                                              [_vm._v("----------")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "option",
                                              { attrs: { value: "2" } },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "account_tb.status.OK"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "option",
                                              { attrs: { value: "KO" } },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "account_tb.status.KO"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "option",
                                              { attrs: { value: "4" } },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "account_tb.status.RUN"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "option",
                                              { attrs: { value: "3" } },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "account_tb.status.CONF_NOT_FOUND"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "option",
                                              { attrs: { value: "GRIS" } },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "account_tb.status.NULL"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("b-col", { attrs: { cols: "2" } }, [
                                      _c("div", [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "filter-item-title d-block mb-1",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "injection_tab.select_t_c_status"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.filterForm.testCaseResult,
                                                expression:
                                                  "filterForm.testCaseResult",
                                              },
                                            ],
                                            staticClass:
                                              "filter-item-content w-100",
                                            staticStyle: { padding: "0.5rem" },
                                            on: {
                                              change: function ($event) {
                                                var $$selectedVal =
                                                  Array.prototype.filter
                                                    .call(
                                                      $event.target.options,
                                                      function (o) {
                                                        return o.selected
                                                      }
                                                    )
                                                    .map(function (o) {
                                                      var val =
                                                        "_value" in o
                                                          ? o._value
                                                          : o.value
                                                      return val
                                                    })
                                                _vm.$set(
                                                  _vm.filterForm,
                                                  "testCaseResult",
                                                  $event.target.multiple
                                                    ? $$selectedVal
                                                    : $$selectedVal[0]
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "option",
                                              {
                                                attrs: {
                                                  value: "",
                                                  selected: "",
                                                },
                                              },
                                              [_vm._v("----------")]
                                            ),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.uniqueExpectedResults,
                                              function (result) {
                                                return _c(
                                                  "option",
                                                  {
                                                    key: result,
                                                    domProps: { value: result },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(result) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                          ],
                                          2
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      {
                                        staticClass: "filter-item",
                                        attrs: { cols: "2" },
                                      },
                                      [
                                        _c("input-filter-dropdown-list", {
                                          attrs: {
                                            "reset-trigger": _vm.resetSignal,
                                            label: _vm.$t(
                                              "toolbox.filtre_case_summary"
                                            ),
                                            "item-list": _vm.AllRowName,
                                            "trad-path":
                                              "toolbox.resp_summary_case",
                                          },
                                          on: { "update-val": _vm.updateVal },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("b-col", { attrs: { cols: "2" } }, [
                                      _c(
                                        "div",
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "filter-item-title d-block mb-1",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "injection_tab.date_begin"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("datetime-picker-custom", {
                                            staticClass: "mr-3",
                                            class: {
                                              "filter-item-input": true,
                                              "filter-item-input-complete":
                                                _vm.filterForm.dateBegin,
                                            },
                                            attrs: {
                                              format: "YYYY-MM-DD HH:mm:ss",
                                              periodFull: "",
                                              id: "filter-datebegin",
                                              customInputParentClass:
                                                "filter-item-content",
                                              customInputClass: "w-100",
                                              maxLength: 19,
                                              placeholderValue: _vm.$t(
                                                "common.datetime_picker_empty_date"
                                              ),
                                              inputIcon: "fa-solid fa-calendar",
                                            },
                                            model: {
                                              value: _vm.filterForm.dateBegin,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.filterForm,
                                                  "dateBegin",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "filterForm.dateBegin",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("b-col", { attrs: { cols: "2" } }, [
                                      _c(
                                        "div",
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "filter-item-title d-block mb-1",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "injection_tab.date_end"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("datetime-picker-custom", {
                                            staticClass: "mr-3",
                                            class: {
                                              "filter-item-input": true,
                                              "filter-item-input-complete":
                                                _vm.filterForm.dateEnd,
                                            },
                                            attrs: {
                                              format: "YYYY-MM-DD HH:mm:ss",
                                              periodFull: "",
                                              id: "filter-datebegin",
                                              customInputParentClass:
                                                "filter-item-content",
                                              customInputClass: "w-100",
                                              maxLength: 19,
                                              placeholderValue: _vm.$t(
                                                "common.datetime_picker_empty_date"
                                              ),
                                              inputIcon: "fa-solid fa-calendar",
                                            },
                                            model: {
                                              value: _vm.filterForm.dateEnd,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.filterForm,
                                                  "dateEnd",
                                                  $$v
                                                )
                                              },
                                              expression: "filterForm.dateEnd",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "2" } },
                                      [
                                        _c(
                                          "b-col",
                                          {
                                            staticClass:
                                              "d-flex justify-content-end align-items-center mt-4 px-0",
                                          },
                                          [
                                            _c(
                                              "b-button",
                                              {
                                                staticClass:
                                                  "btnResetFilter mr-2 px-3 py-1 w-auto col-5",
                                                attrs: { variant: "secondary" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.resetFilterForm()
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "injection_tab.reset"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-button",
                                              {
                                                staticClass:
                                                  "btnDoFiler px-3 py-1 w-auto col-5",
                                                attrs: { variant: "primary" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.applyFilter()
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "injection_tab.search"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("hr", { staticClass: "my-3" }),
                            _vm._v(" "),
                            _vm.activateSpinner
                              ? _c(
                                  "b-row",
                                  {
                                    staticClass: "mb-3 justify-content-center",
                                  },
                                  [_c("spinner")],
                                  1
                                )
                              : _vm.testsCasesFiltered.length > 0
                              ? _c(
                                  "b-row",
                                  { staticClass: "mb-3 justify-content-start" },
                                  [
                                    _c("b-table", {
                                      staticClass:
                                        "table table-striped cursor-pointer",
                                      attrs: {
                                        responsive: "",
                                        hover: "",
                                        "current-page": _vm.pageCounter,
                                        fields: _vm.fieldsTestsCasesTab,
                                        items: _vm.testsCasesFiltered,
                                        "per-page":
                                          _vm.paginationObject.maxResults,
                                        "sort-by": _vm.sortBy,
                                        "sort-desc": _vm.sortDir,
                                      },
                                      on: {
                                        "update:sortBy": function ($event) {
                                          _vm.sortBy = $event
                                        },
                                        "update:sort-by": function ($event) {
                                          _vm.sortBy = $event
                                        },
                                        "update:sortDesc": function ($event) {
                                          _vm.sortDir = $event
                                        },
                                        "update:sort-desc": function ($event) {
                                          _vm.sortDir = $event
                                        },
                                        "head-clicked": _vm.sortTable,
                                        "row-clicked": _vm.openTestCaseDetails,
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "head(select)",
                                          fn: function () {
                                            return [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.selectAll,
                                                    expression: "selectAll",
                                                  },
                                                ],
                                                staticClass: "checkbox-lg",
                                                attrs: { type: "checkbox" },
                                                domProps: {
                                                  checked: Array.isArray(
                                                    _vm.selectAll
                                                  )
                                                    ? _vm._i(
                                                        _vm.selectAll,
                                                        null
                                                      ) > -1
                                                    : _vm.selectAll,
                                                },
                                                on: {
                                                  change: [
                                                    function ($event) {
                                                      var $$a = _vm.selectAll,
                                                        $$el = $event.target,
                                                        $$c = $$el.checked
                                                          ? true
                                                          : false
                                                      if (Array.isArray($$a)) {
                                                        var $$v = null,
                                                          $$i = _vm._i($$a, $$v)
                                                        if ($$el.checked) {
                                                          $$i < 0 &&
                                                            (_vm.selectAll =
                                                              $$a.concat([$$v]))
                                                        } else {
                                                          $$i > -1 &&
                                                            (_vm.selectAll = $$a
                                                              .slice(0, $$i)
                                                              .concat(
                                                                $$a.slice(
                                                                  $$i + 1
                                                                )
                                                              ))
                                                        }
                                                      } else {
                                                        _vm.selectAll = $$c
                                                      }
                                                    },
                                                    _vm.toggleAllRows,
                                                  ],
                                                },
                                              }),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                        {
                                          key: "cell(caseSummary)",
                                          fn: function (data) {
                                            return [
                                              _c("div", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        `toolbox.resp_summary_case.${data.item.caseSummary}`
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]),
                                            ]
                                          },
                                        },
                                        {
                                          key: "cell(select)",
                                          fn: function (data) {
                                            return [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.selectedTestsCases,
                                                    expression:
                                                      "selectedTestsCases",
                                                  },
                                                ],
                                                staticClass: "checkbox-lg",
                                                attrs: { type: "checkbox" },
                                                domProps: {
                                                  value: data.item.id,
                                                  checked: Array.isArray(
                                                    _vm.selectedTestsCases
                                                  )
                                                    ? _vm._i(
                                                        _vm.selectedTestsCases,
                                                        data.item.id
                                                      ) > -1
                                                    : _vm.selectedTestsCases,
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    var $$a =
                                                        _vm.selectedTestsCases,
                                                      $$el = $event.target,
                                                      $$c = $$el.checked
                                                        ? true
                                                        : false
                                                    if (Array.isArray($$a)) {
                                                      var $$v = data.item.id,
                                                        $$i = _vm._i($$a, $$v)
                                                      if ($$el.checked) {
                                                        $$i < 0 &&
                                                          (_vm.selectedTestsCases =
                                                            $$a.concat([$$v]))
                                                      } else {
                                                        $$i > -1 &&
                                                          (_vm.selectedTestsCases =
                                                            $$a
                                                              .slice(0, $$i)
                                                              .concat(
                                                                $$a.slice(
                                                                  $$i + 1
                                                                )
                                                              ))
                                                      }
                                                    } else {
                                                      _vm.selectedTestsCases =
                                                        $$c
                                                    }
                                                  },
                                                },
                                              }),
                                            ]
                                          },
                                        },
                                        {
                                          key: "cell(AllStatusOk)",
                                          fn: function (data) {
                                            return [
                                              data.value === "2" ||
                                              data.item.AllStatusOk == "OK"
                                                ? _c("i", {
                                                    staticClass:
                                                      "fas fa-check bg-success text-white",
                                                    staticStyle: {
                                                      "border-radius": "50%",
                                                      display: "inline-flex",
                                                      "justify-content":
                                                        "center",
                                                      "align-items": "center",
                                                    },
                                                    attrs: { title: "OK" },
                                                  })
                                                : data.value === "0" ||
                                                  data.item.AllStatusOk == "KO"
                                                ? _c("i", {
                                                    staticClass:
                                                      "fas fa-times bg-danger text-white",
                                                    staticStyle: {
                                                      "border-radius": "50%",
                                                      display: "inline-flex",
                                                      "justify-content":
                                                        "center",
                                                      "align-items": "center",
                                                    },
                                                    attrs: { title: "KO" },
                                                  })
                                                : data.value === "4"
                                                ? _c("i", {
                                                    staticClass:
                                                      "fas fa-hourglass-half",
                                                    staticStyle: {
                                                      color: "gray",
                                                      "font-size": "20px",
                                                    },
                                                    attrs: { title: "Pending" },
                                                  })
                                                : data.value === "3"
                                                ? _c("i", {
                                                    staticClass:
                                                      "fas fa-file-alt",
                                                    staticStyle: {
                                                      color: "gray",
                                                      "font-size": "20px",
                                                    },
                                                    attrs: {
                                                      title:
                                                        "Missing configuration",
                                                    },
                                                  })
                                                : data.value === "5" ||
                                                  data.item.AllStatusOk ==
                                                    "GRIS"
                                                ? _c("i", {
                                                    staticClass:
                                                      "fas fa-minus bg-secondary text-white",
                                                    staticStyle: {
                                                      "border-radius": "50%",
                                                      display: "inline-flex",
                                                      "justify-content":
                                                        "center",
                                                      "align-items": "center",
                                                    },
                                                    attrs: {
                                                      title: "Not tested yet",
                                                    },
                                                  })
                                                : _c("p", [
                                                    _vm._v(_vm._s(data.value)),
                                                  ]),
                                            ]
                                          },
                                        },
                                        {
                                          key: "cell(criticity)",
                                          fn: function (data) {
                                            return [
                                              data.value === "1"
                                                ? _c("p", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "injection_tab.criticityLevel.low"
                                                        )
                                                      )
                                                    ),
                                                  ])
                                                : data.value === "2"
                                                ? _c("p", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "injection_tab.criticityLevel.medium"
                                                        )
                                                      )
                                                    ),
                                                  ])
                                                : data.value === "3"
                                                ? _c("p", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "injection_tab.criticityLevel.high"
                                                        )
                                                      )
                                                    ),
                                                  ])
                                                : data.value === "4"
                                                ? _c("p", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "injection_tab.criticityLevel.critical"
                                                        )
                                                      )
                                                    ),
                                                  ])
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                        {
                                          key: "cell(datasetNumber)",
                                          fn: function (data) {
                                            return [
                                              _c("p", [
                                                _vm._v(
                                                  _vm._s(data.item.nbDatasets)
                                                ),
                                              ]),
                                            ]
                                          },
                                        },
                                        {
                                          key: "cell(lastExecution)",
                                          fn: function (data) {
                                            return [
                                              _c("p", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("formatDateTime")(
                                                      data.value
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ]
                                          },
                                        },
                                        {
                                          key: "cell(action)",
                                          fn: function (data) {
                                            return [
                                              _c(
                                                "b-button",
                                                {
                                                  staticClass:
                                                    "btnExecute mx-2 px-2 py-1 w-auto",
                                                  attrs: {
                                                    variant: "primary",
                                                    disabled:
                                                      _vm.hasRightExecution(),
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.runTestCase(
                                                        data.item
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "injection_tab.send"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ]),
                                    }),
                                  ],
                                  1
                                )
                              : _c(
                                  "b-row",
                                  {
                                    staticClass: "pb-3 justify-content-center",
                                  },
                                  [
                                    _c("p", [
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "injection_tab.no_result_test_case"
                                            )
                                          )
                                        ),
                                      ]),
                                    ]),
                                  ]
                                ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { staticClass: "pb-3 justify-content-center" },
                              [
                                _c("cm-pagination", {
                                  attrs: {
                                    maxResultsByPage:
                                      _vm.paginationObject.maxResults,
                                    firstIndex: _vm.paginationObject.firstIndex,
                                    nbResultsTotal:
                                      _vm.paginationObject.nbResultsTotal,
                                    refreshEvent: _vm.paginationObject.refresh,
                                  },
                                  on: { reset: _vm.resetSelectAll },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.testsCasesFiltered.length > 0
                              ? _c(
                                  "b-row",
                                  {
                                    staticClass: "pb-3 justify-content-center",
                                  },
                                  [
                                    !this.hasRightExecution()
                                      ? _c(
                                          "b-button",
                                          {
                                            staticClass:
                                              "btnExecute mx-2 px-2 py-1 w-auto",
                                            attrs: { variant: "primary" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.runTestsCases()
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "injection_tab.execute_selected_cases"
                                                )
                                              )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !this.hasRightExecution()
                                      ? _c(
                                          "b-button",
                                          {
                                            staticClass:
                                              "btnFilter mx-2 px-2 py-1 w-auto",
                                            on: {
                                              click: function ($event) {
                                                return _vm.runAllTest()
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "fa-light fa-repeat fs-14px",
                                            }),
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.$t("common.run_all_test")
                                                ) +
                                                "\n              "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }